<div class="modal-header">
    <button class="close" type="button" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Service Assistance</h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="mvd_form-group col-md-4">
            <label>Type</label>
            <input class="mvd_form-control" type="text" disabled value="{{requestData.escalationType}}" />
        </div>
        <div class="mvd_form-group col-md-4">
            <label>Service</label>
            <input class="mvd_form-control" type="text" disabled value="{{requestData.transactionType}}" />
        </div>
        <div class="mvd_form-group col-md-4">
            <label>Area</label>
            <input class="mvd_form-control" type="text" disabled value="{{requestData.domain}}" />
        </div>
    </div>

    <div class="row">
        <div class="mvd_form-group col-sm-12" title="{{ requestData.validationMessage }}">
            <label>Description</label>
            <div class="mvd_form-control" *ngIf="data && requestData.validationMessage">{{ requestData.validationMessage }}</div>
        </div>
    </div>

    <h2>Service Assistance History</h2>
    <p-table [value]="overrideHistory">
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="5">
                    No records found
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th [pSortableColumn]="'type'">Type<p-sortIcon [field]="'type'"></p-sortIcon></th>
                <th [pSortableColumn]="'description'">Description<p-sortIcon [field]="'description'"></p-sortIcon></th>
                <th [pSortableColumn]="'requestedBy'">Requested By<p-sortIcon [field]="'requestedBy'"></p-sortIcon></th>
                <th [pSortableColumn]="'assignedTo'">Assigned To<p-sortIcon [field]="'assignedTo'"></p-sortIcon></th>
                <th [pSortableColumn]="'outcome'">Outcome<p-sortIcon [field]="'outcome'"></p-sortIcon></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-expanded="expanded">
            <tr [pSelectableRow]="data">
                <td>{{data.type}}</td>
                <td>{{data.description}}</td>
                <td>{{data.requestedBy}} ({{data.requestedByDateTime | date:'M/d/yyyy'}})</td>
                <td>{{data.assignedTo }}  ({{data.assignedToDateTime | date:'M/d/yyyy'}})</td>
                <td>{{data.outcome}}</td>
            </tr>
        </ng-template>
</p-table>

    <div class="row">
        <div class="mvd_form-group col-sm-8">
            <label>Requested By</label>
            <input class="mvd_form-control" type="text" disabled value="{{requestData.overrideRequestedByName}} ({{requestData.overrideRequestedDateTime | date:'M/d/yyyy'}})" />
        </div>
    </div>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--primary" type="button" (click)="cancel()">Close</button>
    </div>
</div>
